// extracted by mini-css-extract-plugin
export var breedcarouselinner = "SectionBreedCarousel-module--breedcarouselinner--acd6c";
export var textWrapper = "SectionBreedCarousel-module--textWrapper--9ab8a";